import { Volume2, VolumeX } from "lucide-react";
import { toast } from "sonner";
import { useData } from "../context/DataContext";
import { sfx } from "../lib/sound";

export function useSound() {
  const { prefs } = useData();
  return !!prefs.sound_effects;
}

export function SoundToggle({ place, className = "" }: { place: string; className?: string }) {
  const { prefs, setPrefs } = useData();
  const on = !!prefs.sound_effects;
  const toggle = () => {
    const next = !on;
    setPrefs({ sound_effects: next });
    if (next) {
      sfx.unlock();
      sfx.tick();
    } else sfx.stopAll();
    toast.success(next ? "Sound on — game-show mode" : "Sound off");
  };
  return (
    <button onClick={toggle} aria-pressed={on} aria-label={on ? "Turn sound off" : "Turn sound on"} data-testid={`sound-toggle-${place}`} data-on={on}
      className={`btn-pop inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-extrabold uppercase ${on ? "bg-pop-yellow" : "bg-white"} ${className}`}>
      {on ? <Volume2 className="h-4 w-4" strokeWidth={3} /> : <VolumeX className="h-4 w-4" strokeWidth={3} />}
      {on ? "Sound on" : "Sound off"}
    </button>
  );
}
